'use strict';

const isMedium = require('../utils/isMedium');

function setToggleAccessibility($toggle, interactive, expanded) {
	if (interactive) {
		$toggle.attr({
			role: 'button',
			tabindex: '0',
			'aria-expanded': String(!!expanded),
			'aria-controls': $toggle.data('menu-id'),
		});
		return;
	}

	$toggle.removeAttr('role');
	$toggle.removeAttr('tabindex');
	$toggle.removeAttr('aria-expanded');
	$toggle.removeAttr('aria-controls');
}

function syncFooterMenuInteraction() {
	const interactive = !isMedium();
	$('.footer-menu').each(function syncMenu() {
		const $menu = $(this);
		const $toggle = $menu.find('.footer-menu__toggle').first();
		const isOpen = $menu.hasClass('is-open');

		if (!interactive && isOpen) {
			$menu.removeClass('is-open');
		}

		setToggleAccessibility($toggle, interactive, interactive && isOpen);
	});
}

$(() => {
	$(document).on('click keypress', '.footer-menu__toggle', function onFooterMenuToggle(e) {
		if (e.type === 'keypress' && e.which !== 13 && e.which !== 32) return;
		if (isMedium()) return;

		const $toggle = $(this);
		const $menu = $toggle.closest('.footer-menu');
		const isOpen = $menu.hasClass('is-open');

		$menu.toggleClass('is-open');
		setToggleAccessibility($toggle, true, !isOpen);
	});

	syncFooterMenuInteraction();
	$(window).on('resize', syncFooterMenuInteraction);
});
